<template>
    <div
      id="mobile_nav_indise"
      :class="[
        'mobile_nav_indise',
        cut ? 'light' : 'dark',
        move ? 'move_top' : 'move_back',
      ]"
    >
    <img :src="logo" alt="" style="width: 1.4rem" />
    <div :style="{color:color,fontWeight:'700'}">鼎函科技</div>
    <div class="img_con"  @click="getMenu()">
        <img
          @click="getMenu()"
          :src="menu"
          alt=""
          style="width: 1.5rem"

        />
    </div>
    
      
     
      <!-- <mt-popup v-model="popupVisible"  position="right">
        <div style="width: 5.43rem; height: 5.5rem; background: red"></div>
      </mt-popup> -->
    </div>
  </template>
  
  <script>
  import { Popup } from "mint-ui";
  export default {
    name: "",
    mixins: [],
    components: {
      Popup,
    },
    props: {
      theme_: {
        type: String,
        default: "",
      },
      click_menu:{
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        popupVisible: false,
        theme: "light",
        cut: false,
        move: false,
        theme_obj: {
          light: {
            logo: require("../../assets/logo-light.png"),
            menu: require("../../assets/home_light.png"),
            color:'#FFFFFF'
          },
          dark: {
            logo: require("../../assets/dinghan-logo.png"),
            menu: require("../../assets/home_dark.png"),
            color:'#1A3862'
          },
        },
        // logo:'',
        // menu:'',
        dark_home: require("../../assets/home_dark.png"),
        light_home: require("../../assets/home_light.png"),
        menu_list:[
          {name:'产品服务',i:'0'},
          {name:'公司介绍',i:'1'},
          {name:'最新动态',i:'2'},
         
        ],
     
      };
    },
    computed: {
      logo() {
        return this.theme_obj[this.theme].logo;
      },
      menu() {
        return this.theme_obj[this.theme].menu;
      },
      color() {
        return this.theme_obj[this.theme].color;
      }
    },
    watch: {
      theme: {
        handler(newVal, oldVal) {
          console.log("监听", newVal, oldVal);
        },
      },
    },
    created() {},
    mounted() {
      this.theme = this.theme_;
      this.onPageScroll();
     
    },
    methods: {
      onPageScroll() {
        let scroll = 0;
        let that = this;
        let dom = document.querySelector("#mobile_nav_indise");
        let height = dom.getBoundingClientRect().height;
        let img_dom_height =  document.querySelector(".mobile_inside").getBoundingClientRect().height
        let clientWidth = document.documentElement.clientWidth || window.innerWidth
        let prop = 375/342
        console.log('sss',img_dom_height,clientWidth / prop)
        let img_height =img_dom_height?img_dom_height: (clientWidth / prop)
        window.addEventListener("scroll", function () {
          if (window.scrollY < height && window.scrollY > 0) {
            // 透明
            that.cut = true;
            that.move = false;
            that.theme = "dark";
          } else if (window.scrollY == height) {
            // 位移
            // that.move = true;
          } else if (window.scrollY > height) {
            // 回退
            if (window.scrollY < scroll) {
              that.theme = "dark";
              that.cut = true;
              that.move = false;
            } else if (window.scrollY >= scroll) {
              // 前进
              // that.move = true;
            }
          } else if (window.scrollY == 0) {
            that.cut = false;
            that.move = false;
            that.theme = "light";
          }
          if(window.scrollY > img_height){
            that.fixed = true
            that.$emit('goScroll',true)
          }else{
            that.fixed = false
            that.$emit('goScroll',false)
          }
          scroll = window.scrollY;
          


        });
      },
      getMenu() {
        this.$router.replace({ path: "/mobile" });
      },
      goScroll(item){
        this.popupVisible = false
        setTimeout(()=>{
          let element = document.getElementById("title_"+item.i)
        element.scrollIntoView({
          behavior:'smooth',
        });
        },200)
        
      }
    },
  };
  </script>
  
  <style scoped >
  .mobile_nav_indise {
    width: 100%;
    height: 2.4rem;
    /* background: rgb(26, 56, 98); */
    position: fixed;
    z-index: 1999;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0.8rem;
    box-sizing: border-box;
    left: 0;
    top: 0;
  }
  .light {
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
    /* animation: light_animate 3s linear normal; */
    transition: .4s ease-out; 
  }
  .dark {
    background: rgb(255, 255, 255, 0.1);
    /* animation: dark_animate 0.6s linear normal; */
    transition: .4s ease-out; 
  }
  .move_top {
    top: -2.4rem;
    animation: move_top 0.1s linear normal;
  }
  .move_back {
    top: 0;
    animation: move_back 0.1s linear normal;
  }
  @keyframes light_animate {
    from {
      background: rgb(255, 255, 255, 0.1);
    }
    to {
      background: rgb(255, 255, 255);
    }
  }
  
  @keyframes dark_animate {
    from {
      background: rgb(255, 255, 255);
    }
    to {
      background: rgb(255, 255, 255, 0.1);
    }
  }
  
  @keyframes move_top {
    from {
      top: 0;
    }
    to {
      top: -2.4rem;
    }
  }
  @keyframes move_back {
    from {
      top: -2.4rem;
    }
    to {
      top: 0;
    }
  }
  .menu_list {
    width: 6.7rem;
    height: 6.5rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
  
  
  }
  .menu_pop{
      top: 2.4rem;
      right: 0;
      bottom: auto;
      left:auto;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
      transition: .2s ease-out;  
      
  }
  .menu_bcg_dark{
    background: rgb(255, 255, 255, 0.1);
    color: #fff;
    transition: .2s ease-out;  
  }
  .menu_bcg_light{
    background: rgba(255, 255, 255, 1);
    color: #2b2b2b;
    transition: .2s ease-out;  
  }
  /deep/.v-modal{
     opacity: .0; 
  }
  .middle_logo{
    display: flex;
    align-items: center;
  }
  .middle_logo p{
    display: inline-block
  }
  .img_con{
  width: 2rem;
  display: flex;
  justify-content: flex-end;
}
  </style>
  